import { useMemo } from "react";
import { useReactFlow } from "@xyflow/react";
import { getHandleStyle, isHandleConnected } from "../SequenceNodeHandles";

const CASE_HANDLE_COLOR = "var(--pi-yellow)";
const CASE_HANDLE_OFFSET = "calc(-10px - 16px - 2px)";

export default function useSwitchCaseNodePreview(
  nodeId: string,
  caseId: string,
) {
  const { getEdges, getNode } = useReactFlow();
  const edges = getEdges();
  const node = getNode(nodeId);
  const selected = node?.selected ?? false;
  const customColor = (node?.data as { color?: string } | undefined)?.color;

  const handleStyle = useMemo(
    () =>
      getHandleStyle(
        isHandleConnected(nodeId, caseId, "source", edges),
        selected,
        customColor,
        "default",
        {
          position: "absolute",
          right: CASE_HANDLE_OFFSET,
          top: "calc(50% + 16px)",
          transform: "translateY(-50%)",
        },
        CASE_HANDLE_COLOR,
      ),
    [caseId, customColor, edges, nodeId, selected],
  );

  return { handleStyle };
}
